/* FalcX PDP stock line: keeps the server-rendered dispatch line in step with the selected variant.
   The server already renders the right state for the initial variant; this only reacts to variant changes.
   r8 sweep: also the "Sold out for now" line (exported for tests as module.exports.soldOutHidden).
   r9 (pdp): the server prints only the selected option's true state. A line for the other state (another option in stock,
   or sold out) waits in a <template data-falcx-stock-tpl> / <template data-falcx-soldout-tpl>; it is copied into the page
   the first time it is needed (lineFrom), so the HTML never carries "In stock" and "Sold out" side by side. */
(function () {
  'use strict';
  /* Hide the sold-out line? `map` is {variantId: available}. Unknown variant: keep what is shown (`current`). */
  function soldOutHidden(map, id, current) { return id && map && id in map ? map[id] !== false : current; }
  /* r9: the element for `sel` inside `box`; if absent and `want` is true, cloned in from its <template tplSel> (the
     template is then removed). Returns null when there is nothing to show and nothing to copy. */
  function lineFrom(box, sel, tplSel, want) {
    var el = box.querySelector(sel);
    if (el || !want) return el;
    var tpl = box.querySelector(tplSel);
    if (!tpl || !tpl.content) return null;
    var frag = tpl.content.cloneNode(true);
    el = frag.querySelector ? frag.querySelector(sel) : null;
    tpl.parentNode.insertBefore(frag, tpl);
    tpl.parentNode.removeChild(tpl);
    return el || box.querySelector(sel);
  }
  if (typeof module === 'object' && module && module.exports) module.exports = { soldOutHidden: soldOutHidden, lineFrom: lineFrom };
  if (typeof window === 'undefined') return;
  if (window.FalcxStock) { window.FalcxStock.update(); return; }
  function flags(box) {
    if (box._falcxFlags) return box._falcxFlags;
    var el = box.querySelector('[data-falcx-stock-data]');
    try { box._falcxFlags = JSON.parse(el ? el.textContent : '{}') || {}; } catch (e) { box._falcxFlags = {}; }
    return box._falcxFlags;
  }
  function avail(box) {
    if (box._falcxAvail) return box._falcxAvail;
    var el = box.querySelector('[data-falcx-avail-data]');
    try { box._falcxAvail = JSON.parse(el ? el.textContent : '{}') || {}; } catch (e) { box._falcxAvail = {}; }
    return box._falcxAvail;
  }
  /* r8 sweep: the "Sold out for now" line follows the selected option; a notify signup coming back opens its form. */
  function soldOut(box, id) {
    var map = avail(box);
    var hide = soldOutHidden(map, id, true);
    var row = lineFrom(box, '[data-falcx-soldout]', 'template[data-falcx-soldout-tpl]', !hide);
    if (row) row.hidden = soldOutHidden(map, id, row.hidden);
    var d = box.querySelector('[data-falcx-restock]');
    if (d && !d.open && window.location.hash === '#' + d.getAttribute('data-falcx-restock')) d.open = true;
  }
  function currentVariant(box) {
    var scope = box.closest('.shopify-section') || document;
    var input = scope.querySelector('product-form-component input[name="id"], form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return String(input.value);
    var param = new URLSearchParams(window.location.search).get('variant');
    return param ? String(param) : null;
  }
  function update() {
    document.querySelectorAll('[data-falcx-stock]').forEach(function (box) {
      var id = currentVariant(box);
      soldOut(box, id);
      var map = flags(box);
      if (!id || !(id in map)) return; /* unknown variant: keep the server-rendered state */
      var line = lineFrom(box, '[data-falcx-stock-line]', 'template[data-falcx-stock-tpl]', !!map[id]);
      if (line) line.hidden = !map[id];
    });
  }
  function later() { setTimeout(update, 0); setTimeout(update, 400); }
  window.FalcxStock = { update: update };
  document.addEventListener('change', later);
  document.addEventListener('variant:update', later);
  document.addEventListener('shopify:section:load', later);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, { once: true });
  else update();
})();